// @ts-check
import React from "react"
import { numberFormatter } from "../../../utils/numbers.utils"
import { EditedAfterFinishedBadge } from "../CellReportBadges.molecule"

/**
 * @param {import("./SisuTimeCell.molecule").SisuTimeCellProps} props
 * @returns {JSX.Element | null}
 */
export function SisuTimeCell(props) {
  const { ctx } = props
  const { row, getValue } = ctx
  const sisuTime = getValue()
  const isPlaceholder = row.original?.isPlaceholder

  if (isPlaceholder) {
    return null
  }

  return (
    <div className="flex gap-1">
      <span className={row.getIsGrouped() ? "font-bold" : ""}>
        {numberFormatter(sisuTime)}
      </span>
      {!row.getIsGrouped() && row.original?.sisuTimeModifiedAfterFinished ?
        <EditedAfterFinishedBadge tooltipValue="Los tiempos registrados fueron editados después de finalizar el día." />
      : null}
    </div>
  )
}
